import { FILTER_SECTION } from "web/react/components/filters-emo/filter-utils";
import { BaseFilterOption, UniversalFiltersData } from "web/types/universal-filters";

export function extractSelectedDesignerFromFilters(
    filters: UniversalFiltersData
): BaseFilterOption | undefined {
    const brandFilterOptions = filters.filter_section_list.find(
        (section) => section.id === FILTER_SECTION.brandFilter
    )?.option_groups[0].options as BaseFilterOption[];
    return brandFilterOptions.find((option) => option.checked);
}
